import { BORTransferRequestSearchQuery } from '@lio/api-types';

export const borTransferRequestQueryKeys = {
  all: ['bor-transfer-request'] as const,
  search: (params: BORTransferRequestSearchQuery) => [...borTransferRequestQueryKeys.all, 'search', params] as const,
  detail: (id: string) => [...borTransferRequestQueryKeys.all, id] as const,
};
